import React, { ReactNode } from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import ResponsiveWidthBox, {
  ResponsiveWidthBoxProps,
} from 'src/components/shared/responsiveWidthBox/responsiveWidthBox';

interface NewJmPageTitleProps {
  title?: string;
  subtitle?: string;
}

type NewJMRPageMainBodyProps = ResponsiveWidthBoxProps & NewJmPageTitleProps;

/**
 * Wrapper for a New JMR page. Fixes footer to the bottom.
 */
export const NewJMRPageWrapper = (props: { children: ReactNode }) => {
  const { children } = props;
  return (
    <Column alignmentHorizontal="stretch" alignmentVertical="justify" height="100%" heights={['fill', 'fit']}>
      {children}
    </Column>
  );
};

/**
 * Make the main body 100% height.
 */
export const NewJMRPageMainBody = ({ title, subtitle, ...props }: NewJMRPageMainBodyProps) => {
  const { children } = props;
  return (
    <Box overflowY="auto">
      <Row alignmentHorizontal="center" alignmentVertical="top">
        <ResponsiveWidthBox spacingInset="400" {...props}>
          {(!!title || !!subtitle) && <NewJmrPageTitle title={title} subtitle={subtitle} />}
          {children}
        </ResponsiveWidthBox>
      </Row>
    </Box>
  );
};

/**
 * New JMR Page title
 */
export const NewJmrPageTitle = ({ title, subtitle }: NewJmPageTitleProps) => {
  return (
    <Column spacing="200">
      <Text type="h300" data-cy="new-jmr__title">
        {title}
      </Text>
      {subtitle && (
        <Text type="b300" color="secondary">
          {subtitle}
        </Text>
      )}
    </Column>
  );
};

/**
 * Footer for the new JMR Buttons.
 */
export const NewJMRPageFooter = (props: { leftSideContent?: ReactNode; children: ReactNode }) => {
  const { leftSideContent, children } = props;
  return (
    <Box data-testid="newJmrPageFooter">
      <Divider />
      <Row
        widths="fit"
        alignmentHorizontal="justify"
        alignmentVertical="center"
        spacingInset="400 600 400 600"
        height="100%"
      >
        <Box>{leftSideContent}</Box>
        <Row spacing="300">{children}</Row>
      </Row>
    </Box>
  );
};
